module.exports = __webpack_public_path__ + "console/img/upload.6195c097.svg";